import { render, staticRenderFns } from "./UnionView.vue?vue&type=template&id=0e510cfa&scoped=true"
import script from "./UnionView.vue?vue&type=script&lang=js"
export * from "./UnionView.vue?vue&type=script&lang=js"
import style0 from "./UnionView.vue?vue&type=style&index=0&id=0e510cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e510cfa",
  null
  
)

export default component.exports